// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/views/bo-core/forgotPassword/forgotPassword.css
// module id = 784
// module chunks = 1